export default {
  brand: {
    primary: '#000038',
    secondary: '#FFCC32',
    tertiary: '#00D8B0',
    quaternary: '#E6F2FF',
  },
};
